import { SignData } from 'src/app/pages/main/module/engineering-application/components/model/SignData';
import { FormItem } from '../../../base-data/area-building/model/form-item-interface';


export const MY_APPLICATION_FORM: FormItem[] = [
  { text: 'Common.OnGoing', value: 'waitting', num: 0 },
  { text: 'Common.Rejected', value: 'reject', num: 2 },
  { text: 'Common.ApprovalCompleted', value: 'signed', num: 1 },
  { text: 'Common.Canceled', value: 'cancel', num: -1 },
  { text: 'Common.FacAssistantCanceled', value: 'facAssistantCanceled', num: -4 }
]

/**
 * applicant:申请者工号  申请者name  申请时间  单号  单据版本
 * signStatus:地点	需求描述	工程分类  单据状况	Target	停留	Status
 */
export const AREA_BUILDING_TABLE_ITEM: SignData = {
  applicant: {
    emplid: '',
    name: '',
    datetime: '',
    formid: '',
    version: ''
  },
  signStatus: []
}
